export enum Permission {
  LandingAdminPanel = 'admin_panel.legacy_permission',
  LandingPageBuilderModify = 'landing_page_builder.modify',
  LandingPageBuilderView = 'landing_page_builder.view',
  StoreConfigsModify = 'store_configs.modify',
  StoreConfigsView = 'store_configs.view',
}
